import React, { FunctionComponent } from 'react';
import { Card } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../../helpers/html.utils';
import sharedStyles from '../recently-viewed-shared.module.scss';
import ProductListing from '../../../user/my-account/product-listing/product-listing-component';
import { ILabel } from '../../../../models/common/label.model';
import { RecentlyViewedItem } from '../../../../../../generated/graphql';
import { CategoryListingItem } from '../../../user/my-account/product-listing/category-listing-item/category-listing-item-component';

type RecentlyViewedCategoriesProps = {
  labels?: ILabel[];
  data?: RecentlyViewedItem[] | null;
  onClickItemCallback?: (category: RecentlyViewedItem) => void;
};

export const RecentlyViewedCategories: FunctionComponent<RecentlyViewedCategoriesProps> = (props: RecentlyViewedCategoriesProps) => {
  return (
    <Card className={`${sharedStyles['overview-card']} ${sharedStyles['list-container']}`} padding={false}>
      <ProductListing
        title={getLabel(props.labels, 'recently_viewed_categories')}
        tabletWidth='29.2rem'
        elt={CategoryListingItem}
        items={props.data?.slice(0, 4) ?? undefined}
        {...props}
      />
    </Card>
  );
};
